import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import { StripedTableCell, StripedTableRow } from "./StripedTable";
import dayjs from "dayjs";
import { interpolate } from "../services/StringService";

export default function PaginatedTable({ rows, columns, defaultRowsPerPage=5 }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page
  };

  return (
    <Paper sx={{ width: "100%" }}>
      <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <StripedTableRow>
              {columns.map((column) => (
                <StripedTableCell
                  key={column.name}
                  align={column.align != null ? column.align : "left"}
                >
                  {column.name}
                </StripedTableCell>
              ))}
            </StripedTableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <StripedTableRow key={row.name ?? row.eid ?? JSON.stringify(row)}>
                  {columns.map((column) => {
                    const customRender = column.render ?? column.component;
                    const cellValue =
                      customRender != null
                        ? customRender(row)
                        : column.formatter != null
                          ? column.type === "date"
                            ? dayjs(row[column.fieldName]).format(column.formatter)
                            : interpolate(column.formatter, row)
                          : row[column.fieldName];

                    return (
                      <StripedTableCell
                        key={`${row.name ?? row.eid ?? JSON.stringify(row)}-${column.name}`}
                        align={column.align != null ? column.align : "left"}
                      >
                        {cellValue}
                      </StripedTableCell>
                    );
                  })}
                </StripedTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
